import styled from "styled-components"
import { Flex } from "@netdata/netdata-ui"

export const Divider = styled(Flex).attrs({
  bacgkround: "disabled",
  height: "1px",
  margin: [2, 6],
})``
